module.exports = __webpack_public_path__ + "static/img/noContent.dcd7b4d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/noContent.png
// module id = ej2/
// module chunks = 0